<template>
    <el-select v-model="value[name]" filterable clearable placeholder="请选择" :disabled="disabled" @change="getTypeVal">
        <el-option
                v-for="(item,index) in list"
                :key="index"
                :label="item.name"
                :value="item.code">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        data() {
            return {
                list: [],
            }
        },
        props: {
            code: {default: ""},
            name: {default: ""},
            value: null,
            disabled: {default: false}
        },
        methods: {
            findList() {
                this.axiosPost("/sysType/findList.do", {code: this.code}, function (resData) {
                    this.list = resData.list;
                });
            },
            getTypeVal(val) {
                this.$emit("change", val);
            }
        },
        mounted() {
            this.findList();
        },
        watch: {
//            param: {
//                handler(newObj, oldObj) {
//                    this.pageNumber = 1;
//                    this.finished = false;
//                    this.$set(this, "list",[]) ;
//                }, deep: true
//            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/kc/keTemp/sysType.vue